import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withHandlers, compose, withProps } from 'recompose';

import config from '../../../config';
import WithShop from '../../hoc/WithShop';
import WithLoader from '../../hoc/WithLoader';
import { fetchShop } from '../../shops/actions';
import FetchOnMount from '../../hoc/FetchOnMount';
import { getBarbers } from '../../barbers/selectors';
import { getExtensionByShopId } from '../../extensions';
import withGiftCardUrlPattern from '../../hoc/WithGiftCardUrlPattern';
import { fetchBarbers, fetchBrandBarbers } from '../../barbers/actions';

function mapStateToProps(state, ownProps) {
  const shopId = ownProps.shop ? ownProps.shop.id : null;
  return {
    barbers: getBarbers(state, ownProps.params),
    extension: getExtensionByShopId(state, shopId),
  };
}

const mapDispatchToProps = {
  fetchShopAction: fetchShop,
  fetchBarbersAction: fetchBarbers,
  fetchBrandBarbersAction: fetchBrandBarbers,
};

export default compose(
  withRouter,
  WithShop,
  withGiftCardUrlPattern,
  connect(mapStateToProps, mapDispatchToProps),
  withProps((props) => {
    if (props.extension && props.location.query.brand) {
      return { shopName: props.extension.name };
    }
    if (props.shop) {
      return { shopName: props.shop.name };
    }
    return { shopName: '' };
  }),
  withHandlers({
    fetchShop: props => () => props.fetchShopAction(
      props.params.shopRoute,
      config.urlPatterns.giftCard,
    ),
    fetchBarbers: props => () => {
      if (props.location.query.brand) {
        return props.fetchBrandBarbersAction(
          props.location.query.brand,
          props.params,
          config.urlPatterns.giftCard,
        );
      }

      return props.fetchBarbersAction(
        props.params.shopRoute,
        props.params,
        config.urlPatterns.giftCard,
      );
    },
  }),
  withHandlers({
    fetchData: props => () => props.fetchShop().then(props.fetchBarbers),
  }),
  FetchOnMount,
  WithLoader,
);



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardLayout/GiftCardLayoutContainer.js